import { Fragment, useEffect, useState } from 'react';

import { GetRecommendationsResponse } from 'algoliasearch';
import dynamic from 'next/dynamic';

import { ALGOLIA_CONFIDENCE_SCORE_THRESHOLD, recommendClient } from '@/config/algolia';
import { ALGOLIA_INDEX_NAME } from '@/config/env';
import { useAppContext } from '@/layouts/AppProvider';

const PopularCategoriesStatic = dynamic(() => import('./PopularCategoriesStatic'));
const RenderSingleCategory = dynamic(() => import('./ui/RenderSingleCategory'));

const PopularCategoriesRecommendations = () => {
  const { isBackOffice } = useAppContext();
  const [isErrored, setErrored] = useState<boolean>(false);
  const [isFetching, setFetching] = useState<boolean>(true);
  const [recommendations, setRecommendations] = useState<GetRecommendationsResponse['results']>([]);

  useEffect(() => {
    async function getRecommendations() {
      try {
        const recommendations = await recommendClient.getRecommendations({
          requests: [
            {
              indexName: ALGOLIA_INDEX_NAME,
              threshold: ALGOLIA_CONFIDENCE_SCORE_THRESHOLD,
              maxRecommendations: 6,
              model: 'trending-facets',
              facetName: isBackOffice ? 'BackofficeCategoriesNames' : 'ReplicatedCategoriesNames',
            },
          ],
        });
        setRecommendations(recommendations?.results || []);
        setFetching(false);
      } catch (error) {
        setErrored(true);
        setFetching(false);
      }
    }
    getRecommendations();
  }, [isBackOffice]);

  const showFallabck = isErrored || (!isFetching && recommendations.every(r => r.hits.length == 0));

  if (showFallabck) return <PopularCategoriesStatic />;

  return (
    <>
      {recommendations.map(r => (
        <Fragment key={`trending-categories-results-${r.page}`}>
          {r.hits.map((h, idx) => (
            <RenderSingleCategory key={`category-${h.facetValue}-${idx}`} category={h.facetValue} />
          ))}
        </Fragment>
      ))}
    </>
  );
};

export default PopularCategoriesRecommendations;
